<template>
    <div>
        <el-tabs class="import-page" type="border-card" v-model="importTab" :style="`width:${ importTab === '1' ? 'auto' : '600px'}`">
            <el-tab-pane label="Template">
                <Template />
            </el-tab-pane>
            <el-tab-pane label="Form">
                <Form />
            </el-tab-pane>
        </el-tabs>
        <DataDefination />
    </div>
</template>

<script>
import Template from './components/Template';
import Form from './components/Form';
import DataDefination from './components/DataDefinition';

export default {
    components: { Template, Form, DataDefination },
    data: () => ({
        importTab: '0'
    })
}
</script>

<style scoped>
.import-page {
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
}
</style>